import { JobPrototype } from '../types'

export const CREATE_JOB = 'CREATE_JOB'
export const UPDATE_JOB = 'UPDATE_NEW_JOB'

export interface CreateJobAction {
    type: typeof CREATE_JOB
    payload: {
        job?: JobPrototype | null
    }
}

export interface UpdateJobAction {
    type: typeof UPDATE_JOB
    payload: {
        job: Partial<JobPrototype>
    }
}

export type ActionType = CreateJobAction | UpdateJobAction

export class Actions {

    static createJob(job?: JobPrototype | null): CreateJobAction {
        return {
            type: CREATE_JOB,
            payload: {
                job: job
            }
        }
    }

    static updateJob(job: Partial<JobPrototype>): UpdateJobAction {
        return {
            type: UPDATE_JOB,
            payload: {
                job: job
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/job.ts